/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>0 - NotDefined</b>: </li>\n<li><b>1 - Opened</b>: Чат открыт</li>\n<li><b>2 - Closed</b>: Чат закрыт</li>\n</ul>\n
 */
export const chatStatusEnumSchema = z.union([z.literal(0), z.literal(1), z.literal(2)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - NotDefined</b>: </li>\n<li><b>1 - Opened</b>: Чат открыт</li>\n<li><b>2 - Closed</b>: Чат закрыт</li>\n</ul>\n")